import script from "./OrderPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPage.vue?vue&type=style&index=0&id=616050f4&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/bj-International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616050f4"]])

export default __exports__